// extracted by mini-css-extract-plugin
module.exports = {"popover-text":"popover-info__popover-text___13yC2"};